'use client';

import React from 'react';
import styled from 'styled-components';

import { Image } from '@zoomit/primitives';
import { Flex, Link, Spacing } from '@zoomit/primitives';
import type { ProductListItemType} from '@zoomit/web-kit';
import { BaseMediaUrl, Price, Score } from '@zoomit/web-kit';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

const ProductSimpleListItemDesktop = (props: ProductListItemType) => {
  const { image, slug, score, minPrice, title } = props;

  return (
    <Flex
      alignItems="center"
      justifyContent="space-between"
      flexWrap={'nowrap'}
      gap={2.6}
      spacing={{ pl: 'x4' }}
    >
      <Flex flexWrap={'nowrap'} gap={Spacing.x4} alignItems="center">
        <Link href={`/${slug}`}>
          <Image
            alt={title}
            src={`${BaseMediaUrl}/${image.id}`}
            width={72}
            height={48}
            placeholder="blur"
            blurDataURL={image.preview}
            style={{ objectFit: 'contain' }}
            sizes="75px"
          />
        </Link>
        <Link href={`/${slug}`} className="**:hover:text-text-hover">
          <EllipsisText lineNumber={1} fontSize={1.3} lineHeight={1.85} tag="span">
            {title}
          </EllipsisText>
        </Link>
      </Flex>
      <Flex gap={Spacing.x7} alignItems="center" flexWrap={'nowrap'}>
        <Price price={minPrice.toLocaleString('ir-IR')} />
        <Flex justifyContent={'flex-end'} alignItems="center" style={{ width: 40 }}>
          {score !== undefined && score !== 0 && <Score score={score} />}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ProductSimpleListItemDesktop;

const EllipsisText = styled(Typography)<{ lineNumber: number }>`
  display: -webkit-box;
  -webkit-line-clamp: ${({ lineNumber }) => lineNumber};
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
`;
